"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const react_use_1 = require("react-use");
exports.useOsmosysStickied = (ms, doit, deps) => {
    const [stickied, toggleStickied] = react_use_1.useToggle(doit);
    react_1.useEffect(() => {
        if (doit && !stickied) {
            toggleStickied(true);
            const t = setTimeout(() => {
                toggleStickied(false);
            }, ms);
            return () => clearTimeout(t);
        }
        else {
            return () => { };
        }
    }, [...deps, react_use_1.useToggle]);
    return stickied;
};
//# sourceMappingURL=useOsmosysStickied.js.map